"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVisionAndStrategy = function IconVisionAndStrategy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M20.879 5.919a3.49 3.49 0 0 1 2.934-1.933l.192-.005a3.49 3.49 0 0 1 3.126 1.938L27.17 6H32v2h5v35H16.009a5.18 5.18 0 0 1-3.506-1.325 4.5 4.5 0 0 1-1.497-3.125L11 38.31V8h5V6h4.84zM32 12v-2h2.999v31H16l-.218-.005a3.18 3.18 0 0 1-1.944-.809l-.14-.135A2.5 2.5 0 0 1 13 38.31L12.999 10H16v2zm-6.532-4.81a1.49 1.49 0 0 0-2.926 0l-.156.81H18v2h12V8h-4.376zM19 32.97a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m10.847.97 1.267 1.266-.708.707-1.266-1.266-1.266 1.267-.708-.708 1.267-1.266-1.267-1.267.708-.707 1.266 1.267 1.266-1.267.708.707zM30 20.81V23a2 2 0 0 1-1.85 1.994L28 25h-8v6h-2v-6a2 2 0 0 1 1.85-1.995L20 23h8v-2.19h-1.79L29 15.97l2.79 4.84zm-10.493-2.96 1.266 1.266-.707.707-1.266-1.266-1.267 1.267-.707-.708 1.267-1.266-1.267-1.267.707-.707 1.267 1.267 1.266-1.267.707.708z",
    clipRule: "evenodd"
  })));
};

export { IconVisionAndStrategy, IconVisionAndStrategy as default };
